import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import PrintIcon from '@mui/icons-material/Print'
import SummarizeIcon from '@mui/icons-material/Summarize'
import VisibilityIcon from '@mui/icons-material/Visibility'
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  List,
  ListItem,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import ListItemText from '@mui/material/ListItemText'
import Paper from '@mui/material/Paper'
import { styled, useTheme } from '@mui/material/styles'
import { useQuery } from '@tanstack/react-query'
import { format } from 'date-fns'
import * as React from 'react'
import { useEffect, useLayoutEffect, useState } from 'react'
import OnlyWithFunction, { isValidUser } from '../../OnlyWithFunctions'
import { getAbilitazioneTastoChiuso } from '../../services/abilitaChiudi'
import { closePratica } from '../../services/closePratica'
import { downloadDocument } from '../../services/downloadDocument'
import { getApprovazioneADV } from 'services/getApprovazioneADV'
import { getEsitoADV } from '../../services/getEsitoADV'
import { getFoldersTree } from '../../services/getFoldersTree'
import { getRiepilogoPdf } from '../../services/getRiepilogoPdf'
import { StyledButton } from '../../UI/StyledButton'
import { OpenPrintPreviewFromByteArray } from '../../utils/OpenPrintPreviewFromByteArray'
import { StatiPratica } from '../../utils/StatiPratica'
import { titlesToolTip } from '../../utils/titlesToolTip'
import DeleteDocument from './DeleteDocument'
import EvidenzaEsitoMonitoraggio from './EvidenzaEsitoMonitoraggio'
import { SezioneGialla } from './SezioneGialla'
import { SezioneBlu } from './SezioneBlu'
import TextFieldCreateFolder from './TextFieldCreateFolder'
import UploadDocument from './UploadDocument'
import { getPraticheDettaglio } from '../../services/getPraticheDettaglio'
import DataTable from '../../Charts/tb'
import { getIndicatoriAdvAutomatica } from '../../services/getIndicatoriAdvAutomatica'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import { restartCaricamentoDoc } from '../../services/restartCaricamentoDoc'

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}))

const AccordionDettaglio = ({
                              //isFetchedIndicatoriPratica,
                              //errorIndicatoriPratica,
                              //indicatoriPratica,
                              //openAdvAutomatica,
                              //openTableState,
                              dettaglioPratica,
                              idNodoPratica,
                              clickDoc,
                              //refetchPraticheDettaglio,
                              valueNDGModal,
                              valueRelazioneModal,
                              //syncStatoRichiesta,
                              refetchPostUpdateFolder,
                              handleReloadDettaglio,
                              handleSyncStatoInLavorazione,
                            }) => {

  const [dataNotAvailable, setDataNotAvailable] = useState(true)
  const tableStyle = {

    //transform: 'translate(30%, -40%)',
    position: 'absolute',
    zIndex: 2000,
// Impostiamo una larghezza minima e massima
    minWidth: '50vw', // Impostiamo una larghezza minima, in modo che non vada mai a 0
    minHeight: '50vh', // Impostiamo una altezza minima
    maxWidth: '50vw', // La larghezza non può superare il 50% della larghezza della finestra
    maxHeight: '50vh', // L'altezza non può superare il 50% dell'altezza della finestra
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 20,
    borderRadius: 2,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  }
  const { statoPratica } = dettaglioPratica
  const [statoRichiesta, setStatoRichiesta] = useState(
    dettaglioPratica.statoPratica,
  )
  //const [dettaglioPratica, setDettaglioPratica] = useState(dettaglioPratica)
  const [expanded, setExpanded] = useState(true)
  const [expandedDet, setExpandedDet] = useState(false)
  const [showButton, setShowButton] = useState(false)
  const [idDocumenti, setIdDocumenti] = useState(undefined)
  const noteUtenteAutorizzativo = dettaglioPratica?.noteUtenteAutorizzativo
  const [loading, setLoading] = useState(false)
  const [documentsToView, setDocumentsToView] = useState([])
  const theme = useTheme()
  const [refetchPraticheAccordion, setRefetchPraticheAccordion] = useState(
    refetchPostUpdateFolder ? refetchPostUpdateFolder : false,
  )
  const [refetchInterval, setRefetchInterval] = useState(0)
  const [refetchIntervalSezioneGialla, setRefetchIntervalSezioneGialla] =
    useState(0)
  const [fileToDownload, setFileToDownload] = useState(undefined)
  const [tipoInserimento, setTipoInserimento] = useState(undefined)
  const [openModal, setOpenModal] = useState(false)
  const [refreshListaDocValue, setRefreshListaDocValue] = useState(
    Number.MIN_SAFE_INTEGER,
  )
  const {
    data: indicatoriPratica,
    isFetched: isFetchedIndicatoriPratica,
    error: errorIndicatoriPratica,
  } = useQuery({
      queryKey: ['indicatori_Pratica', dettaglioPratica.id],
      queryFn: () => getIndicatoriAdvAutomatica(dettaglioPratica.id),
      enabled:
        dettaglioPratica.tipoInserimento === 'Automatica' || dettaglioPratica.tipoInserimento === 'Automatica Medio Rischio' || dettaglioPratica.tipoInserimento === 'Automatica Alto Rischio',
      retry: false,
    },
  )

  const refreshListaDoc = () => {
    setRefreshListaDocValue(refreshListaDocValue + 1)
  }

  /*  const fetchPratica = async () => {
      setIsLoading(true) // Settiamo il loading a true prima della chiamata API
      try {
        const response = await getPraticheDettaglio(idNodoPratica) // Chiamata alla tua API
        setDettaglioPratica(response)
        setRefetchPratiche(false)// Mettiamo le pratiche nel state
      } catch (err) {
        setError('Errore durante il recupero delle pratiche') // Gestiamo gli errori
      } finally {
        setIsLoading(false) // Settiamo il loading a false dopo la chiamata API
      }
    }
    if(isLoading || refetchPratiche)
      fetchPratiche()
  }, [codiceFiscale,refetchPratiche])*/

  const handleDownloadFile = (event, fileId, fileName) => {
    event.preventDefault()
    downloadDocument(fileId, true).then(res =>
      setFileToDownload({ title: fileName, document: res }),
    )
  }
  /*const {
    data: sezioneGiallaSalvata,
    isFetching: isFetchingSezioneGiallaSalvata,
    isLoading: isLoadingSezioneGiallaSalvata,
    isFetched: isFetchedSezioneGiallaSalvata,
  } = useQuery(
    ['sezioneGiallaSalvata', idNodoPratica],
    () => getEsitoADV(idNodoPratica),
    { refetchInterval: refetchIntervalSezioneGialla },
  )*/
  const shouldFetchSezioneGialla = ![
    'In Richiesta',
    'In Lavorazione',
    'Annullata',
  ].includes(dettaglioPratica?.statoPratica)

  const {
    data: sezioneGiallaSalvata,
    isFetching: isFetchingSezioneGiallaSalvata,
    isLoading: isLoadingSezioneGiallaSalvata,
    isFetched: isFetchedSezioneGiallaSalvata,
  } = useQuery(
    ['sezioneGiallaSalvata', idNodoPratica],
    () => getEsitoADV(idNodoPratica),
    {
      enabled: shouldFetchSezioneGialla, // La query viene eseguita solo se `shouldFetchSezioneGialla` è true
      refetchInterval: refetchIntervalSezioneGialla,
    },
  )

  //const attivitaSvolteList = sezioneGiallaSalvata?.attivitaSvolteList || [];

  //['boolean-disabled-tasto-chiuso', idNodoPratica],

  const {
    data: dataAbilitazioneTastoChiuso,
    isFetching: isDataFetching,
    isLoading: isDataLoading,
  } = useQuery(
    ['boolean-disabled-tasto-chiuso', idNodoPratica],
    () => getAbilitazioneTastoChiuso(idNodoPratica),
    { refetchOnMount: 'always' },
  )

  /*  const {
      data: dataDettaglioPratica,
      isFetching: isFetchingDettaglioPratica,
      isLoading: isLoadingDettaglioPratica,
      isFetched: isFetchedDettaglioPratica,
      refetch: refetchDettaglioPratica,
    } = useQuery(
      ['dettaglio_pratica', idNodoPratica],
      // TODO Da scommentare e vedere cosa fare qui
      // () => getNodeChildById(idNodoPratica),
      () => {
      },
      { refetchOnMount: 'always' },
    )*/
  const [responseCode, setResponseCode] = useState(200)
  const {
    data: dataCartelleDocumenti,
    isFetching: isFetchingCartelleDocumenti,
    isLoading: isLoadingCartelleDocumenti,
    isFetched: isFetchedCartelleDocumenti,
  } = useQuery(
    ['cartelle_documenti', idNodoPratica],
    () => getFoldersTree(idNodoPratica),
  )

  const {
    data: dataListaDocumenti,
    isFetching: isFetchingListaDocumenti,
    isLoading: isLoadingListaDocumenti,
    isFetched: isFetchedListaDocumenti,
    refetch: refetchListaDocumenti,
  } = useQuery({
    queryFn: async () => {
      if (!idDocumenti) return []
      return await getFoldersTree(idNodoPratica, idDocumenti)
    },
    queryKey: ['lista_documenti', idNodoPratica, idDocumenti, refreshListaDocValue],
    onSuccess: () => {
      if (responseCode === 202) {
        handleReloadDettaglio()
      } else if (responseCode === 203) {
        //significa che la pratica è passata in Lavorazione
        handleSyncStatoInLavorazione()
        setStatoRichiesta('In Lavorazione')
      }
    },
  })


  useEffect(() => {
    if (fileToDownload) {
      const linkSource = `data:application/pdf;base64,${fileToDownload.document}`
      const downloadLink = document.createElement('a')
      downloadLink.href = linkSource
      downloadLink.download = fileToDownload.title
      downloadLink.click()
    }
  }, [fileToDownload])

  useEffect(() => {
    if (
      isFetchedIndicatoriPratica && !errorIndicatoriPratica && indicatoriPratica
    ) {
      setDataNotAvailable(false)
    }

  }, [indicatoriPratica])

  /*  useEffect(() => {

      syncStatoRichiesta(statoRichiesta)
    }, [statoRichiesta])*/

  /*  useEffect(() => {
      if (
        dataDettaglioPratica &&
        dataDettaglioPratica.length > 0 &&
        dataDettaglioPratica[0].entry &&
        dataDettaglioPratica[0].statoRichiesta !== ''
      ) {
        setStatoRichiesta(
          dataDettaglioPratica[0].statoRichiesta,
        )
        setTipoInserimento(
          dataDettaglioPratica[0].tipoInserimento,
        )
      }
    }, [dataDettaglioPratica])*/

  useEffect(() => {

    if (refetchPostUpdateFolder === true) {
      setRefetchInterval(1000)
      setTimeout(function() {
        setRefetchInterval(0)
        setRefetchPraticheAccordion(false)
      }, 4000)
    }
  }, [refetchPostUpdateFolder])

  const [refetchSezioneGialla, setRefetchSezioneGialla] = useState(false)

  useEffect(() => {
    if (refetchSezioneGialla === true) {
      setRefetchIntervalSezioneGialla(1000)
      setTimeout(function() {
        setRefetchIntervalSezioneGialla(0)
        setRefetchSezioneGialla(false)
      }, 4000)
    }
  }, [refetchSezioneGialla])
  useLayoutEffect(() => {
    var a = dettaglioPratica.ndg

    if (
      statoRichiesta === StatiPratica.inRichiesta ||
      statoRichiesta === StatiPratica.inLavorazione
    ) {
      setShowButton(false)
    } else {
      setShowButton(true)
    }
  }, [dettaglioPratica.ndg])

  const [approvazioneDisponibile, setApprovazioneDisponibile] = useState(false)
  const {
    data: validazioneEsitoAdv,
  } = useQuery(
    {
      queryFn: () => getApprovazioneADV(idNodoPratica).then(data => data.validazioneEsito),
      queryKey: ['approvazioneAdv', idNodoPratica],
      retry: false,
      refetchOnMount: true,
      onSuccess: () => setApprovazioneDisponibile(true),
      onError: () => setApprovazioneDisponibile(false),
    })


  const openTable = event => {
    event.preventDefault()
    event.stopPropagation()
    setStartPol(prevState => !prevState)
  }

  const refreshListaDocAndStatoRichiesta = (code) => {
    if (code === 200 || code === 202 || code === 203) {
      setResponseCode(code)
      refreshListaDoc()
    }
  }

  const handleOpenMenu = documentId => {
    if (!documentsToView.includes(documentId)) {
      setDocumentsToView(oldDocuments => [...oldDocuments, documentId])
    } else {
      setDocumentsToView(oldDocuments =>
        oldDocuments.filter(docId => docId !== documentId),
      )
    }
  }


  const handleOpenModal = () => {
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  const handleConfirmClosePratica = () => {
    debugger
    closePratica(idNodoPratica)
      .then(response => {
        //refetchPraticheDettaglio()
        handleReloadDettaglio()
      })
      .catch(response => {
      })
    setOpenModal(false)
  }

  const handleConfirmAutoRestartCaricamentoDoc = () => {
    restartCaricamentoDoc(idNodoPratica)
      .then(response => {
        //refetchPraticheDettaglio()
        handleReloadDettaglio()
      })
      .catch(response => {
      })
    setOpenModal(false)
  }
  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }

  const handleChangeDet = panel => (event, newExpandedDet) => {
    setExpandedDet(newExpandedDet ? panel : false)
  }
  const uploadPermission = folderName => {
    switch (folderName) {
      case 'Documenti d\'identità':
        if (isValidUser('UPLOAD_DOCUMENTI_IDENTITA')) {
          return false
        } else {
          return true
        }
      case 'Documenti per adeguata verifica': {
        if (isValidUser('UPLOAD_DOCUMENTI_ADV')) {
          return false
        } else {
          return true
        }
      }
      case 'Documenti Banca':
        if (isValidUser('UPLOAD_DOCUMENTI_BANCA')) {
          return false
        } else {
          return true
        }
      default:
        return false
    }
  }

  const getPdf = event => {
    try {
      setLoading(true)
      event.preventDefault()
      event.stopPropagation()
      getRiepilogoPdf(idNodoPratica).then(res => {
        if (res.data.code === 200) {
          OpenPrintPreviewFromByteArray(res.data.body)
          setLoading(false)
        } else setLoading(false)
      })
    } catch (error) {
      alert(error)
      setLoading(false)
    }
  }


  let azioniDaPorreInEssereUnique = []
  let azioniDaPorreInEssere
  let tooltipStatoPraticaChiusa =
    'Cliente a cui è stato assegnato uno score factor \'giallo\' all’interno del GRC per il quale in corso ulteriori approfondimenti condotti in data ' +
    format(
      new Date(dettaglioPratica.dataChiusura),
      'dd/MM/yyyy',
    )
  let finalParteTooltip = ''

  /*if (sezioneGiallaSalvata) {
    azioniDaPorreInEssere = dettaglioPratica?.azioniDaPorreInEssere
    azioniDaPorreInEssereUnique = azioniDaPorreInEssere
    if (sezioneGiallaSalvata?.checkoutOperatore === 'Sono emersi elementi tali da rendere necessaria una attività di adeguata verifica rafforzata' ||
      sezioneGiallaSalvata?.checkoutOperatore === 'E\' stata rilevata la presenza di un PIL- Politico Italiano Locale') {
      finalParteTooltip = sezioneGiallaSalvata?.checkoutOperatore[0]
    }
  } else {
    azioniDaPorreInEssere = data?.azioniDaPorreInEssere
    azioniDaPorreInEssereUnique = azioniDaPorreInEssere
    if (data?.checkoutOperatore === 'Sono emersi elementi tali da rendere necessaria una attività di adeguata verifica rafforzata' ||
      data?.checkoutOperatore === 'E\' stata rilevata la presenza di un PIL- Politico Italiano Locale') {
      finalParteTooltip = data?.checkoutOperatore[0]
    }
  }*/

  function trovaLabelSelezionata(node, targetLabels) {
    if (node.isSelected && targetLabels.includes(node.label)) {
      return node.label
    }
    if (node.children && node.children.length > 0) {
      for (let child of node.children) {
        const labelTrovata = trovaLabelSelezionata(child, targetLabels)
        if (labelTrovata) {
          return labelTrovata
        }
      }
    }
    return null
  }

  if (sezioneGiallaSalvata) {
    azioniDaPorreInEssere = dettaglioPratica?.azioniDaPorreInEssere
    azioniDaPorreInEssereUnique = azioniDaPorreInEssere

    const targetLabels = [
      'Sono emersi elementi tali da rendere necessaria una attività di adeguata verifica rafforzata',
      'E\' stata rilevata la presenza di un PIL- Politico Italiano Locale',
    ]

    const labelSelezionata = trovaLabelSelezionata(sezioneGiallaSalvata?.esitoAdv, targetLabels)
    if (labelSelezionata) {
      finalParteTooltip = labelSelezionata
    }
  }

  if (Array.isArray(azioniDaPorreInEssere)) {
    azioniDaPorreInEssereUnique = [...new Set(azioniDaPorreInEssere)]
  }

  tooltipStatoPraticaChiusa =
    tooltipStatoPraticaChiusa + ' ' + finalParteTooltip

  const isPDF = (fileName) => {
    return fileName.toLowerCase().endsWith('.pdf')
  }
  const [startPol, setStartPol] = useState(false)

  const openAdvAutomatica = startPol => {
    setStartPol(!startPol)
  }
  return (
    <>
      <Accordion
        elevation={0}
        disableGutters
        square={true}
        sx={{
          width: '100%',
          backgroundColor: theme.palette.grey.dark,
          //size: '70%',
          //ml: '20px',
        }}
      >
        <AccordionSummary
          sx={{
            backgroundColor: theme.palette.grey.dark,
          }}
          expandIcon={<ArrowDropDownIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Grid
            container
            display="contents"
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Stack sx={{ width: '9%' }} alignItems="center">
              <Typography
                sx={{ fontWeight: 900, textAlign: 'center' }}
                variant="standard"
              >
                {`NDG`}
              </Typography>

              <Typography sx={{ textAlign: 'center' }} variant="caption">
                {valueNDGModal
                  ? valueNDGModal
                  : dettaglioPratica.ndg}
              </Typography>
            </Stack>
            <Stack
              sx={{ width: '20%' }}
              alignItems="center"
              justifyItems={'start'}
            >
              <Typography
                sx={{ fontWeight: 900, textAlign: 'center' }}
                variant="caption"
              >{`ADEGUATA VERIFICA DEL `}</Typography>
              <Typography variant="caption">
                {`${format(
                  new Date(dettaglioPratica.dataCreazione),
                  'dd/MM/yyyy',
                )}`}
              </Typography>
            </Stack>
            <Stack sx={{ width: '20%' }} alignItems="center">
              {dettaglioPratica.statoPratica === StatiPratica.valutazionePreliminare
                ? <Typography
                  sx={{ fontWeight: 900, textAlign: 'center' }}
                  variant="caption">
                  {`LIVELLO DI RISCHIO`}
                </Typography>
                : <Typography
                  sx={{ fontWeight: 900, textAlign: 'center' }}
                  variant="caption"
                >
                  {`TIPO INSERIMENTO`}
                </Typography>}
              {dettaglioPratica.statoPratica === StatiPratica.valutazionePreliminare
                ? (dettaglioPratica.tipoInserimento === 'Automatica Alto Rischio'
                    ? <Typography sx={{ textAlign: 'center' }} variant="caption">{'Alto'}</Typography>
                    : <Typography sx={{ textAlign: 'center' }} variant="caption">{'Medio'}</Typography>
                )
                : <Typography sx={{ textAlign: 'center' }} variant="caption">
                  {
                    dettaglioPratica.tipoInserimento
                  }
                </Typography>

              }

            </Stack>
            <Stack sx={{ width: '20%' }} alignItems="center">
              <Typography
                sx={{ fontWeight: 900, textAlign: 'center' }}
                variant="caption"
              >
                {`COD. ATECO`}
              </Typography>

              {dettaglioPratica.codiceAteco !== null
                ? <Typography sx={{ textAlign: 'center' }} variant="caption">
                  {dettaglioPratica.codiceAteco}
                </Typography>
                : <Typography sx={{ textAlign: 'center' }} variant="caption">
                  {`N.D.`}
                </Typography>}
            </Stack>

            <Stack sx={{ width: '27%' }} alignItems="center">
              <Typography
                sx={{ fontWeight: 900, textAlign: 'center' }}
                variant="caption"
              >
                {`MOTIVAZIONI DELL'ADEGUATA VERIFICA`}
              </Typography>
              {dettaglioPratica.tipoInserimento === 'Automatica Alto Rischio' ? (
                <IconButton disabled={dataNotAvailable} onClick={openTable}>
                  <VisibilityIcon />
                </IconButton>
              ) : dettaglioPratica.tipoInserimento === 'Automatica Medio Rischio' || '' ? (
                <IconButton disabled={dataNotAvailable} onClick={openTable}>
                  <VisibilityIcon />
                </IconButton>
              ) : dettaglioPratica?.relazione?.toLowerCase() == 'altro' ||
              dettaglioPratica?.relazione?.toLowerCase() == 'esito monitoraggio' ? (
                <div>

                  <Accordion
                    expanded={expandedDet === 'panel1'}
                    onChange={handleChangeDet('panel1')}
                    style={
                      expandedDet
                        ? {
                          minWidth: 200,
                          maxWidth: 100,
                          backgroundColor: 'rgba(255,255,255,0.3)',
                        }
                        : {
                          minWidth: 200,
                          maxHeight: 25,
                          maxWidth: 100,
                          backgroundColor: 'rgba(255,255,255,0.3)',
                        }
                    }
                  >
                    <AccordionSummary
                      expandIcon={
                        <ArrowDropDownIcon
                          sx={
                            expandedDet
                              ? {}
                              : { position: 'relative', bottom: 10 }
                          }
                        />
                      }
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <Typography
                        sx={
                          expandedDet
                            ? { fontSize: 12 }
                            : { position: 'relative', bottom: 10, fontSize: 12 }
                        }
                      >
                        {
                          dettaglioPratica.relazione
                        }
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {dettaglioPratica.dettaglioMotivazione &&

                        <div>
                          <Tooltip title={dettaglioPratica?.dettaglioMotivazione}>
                            <Typography sx={{
                              fontSize: 12, maxWidth: 130,
                              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: 'bold',
                            }}>
                              {`Dettaglio relazione`}

                            </Typography>
                          </Tooltip>
                        </div>}

                    </AccordionDetails>
                  </Accordion>
                </div>
              ) : (
                <div>

                  {dettaglioPratica?.relazione && (
                    <Accordion
                      expanded={expandedDet === 'panel1'}
                      onChange={handleChangeDet('panel1')}
                      style={
                        expandedDet
                          ? {
                            minWidth: 200,
                            maxWidth: 100,
                            backgroundColor: 'rgba(255,255,255,0.3)',
                          }
                          : {
                            minWidth: 200,
                            maxHeight: 150,
                            maxWidth: 100,
                            backgroundColor: 'rgba(255,255,255,0.3)',
                          }
                      }
                    >
                      <AccordionSummary
                        expandIcon={
                          <ArrowDropDownIcon
                            sx={
                              expandedDet
                                ? {}
                                : { position: 'relative', bottom: 10 }
                            }
                          />
                        }
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <Typography sx={{ textAlign: 'center' }} variant="caption">
                          {valueRelazioneModal
                            ? valueRelazioneModal
                            : dettaglioPratica.relazione}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        {(dettaglioPratica.relazione && dettaglioPratica.dettaglioMotivazione) &&
                          <div>
                            <Tooltip title={dettaglioPratica?.dettaglioMotivazione}>
                              <Typography sx={{
                                fontSize: 12, maxWidth: 130, fontWeight: 'bold',
                                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                              }}>
                                {`Dettaglio relazione`}


                              </Typography>
                            </Tooltip>
                          </div>}

                      </AccordionDetails>
                    </Accordion>)}
                </div>


              )}
            </Stack>
            <Stack sx={{ width: '20%' }}>
              <Typography
                sx={{ fontWeight: 900, textAlign: 'center' }}
                variant="caption"
              >
                {`STATO PRATICA`}
              </Typography>

              {dettaglioPratica.statoPratica === StatiPratica.chiusa && dettaglioPratica.dataChiusura
                ? (dettaglioPratica?.tipoInserimento === 'Automatica Medio Rischio'
                  ? (<Tooltip title={tooltipStatoPraticaChiusa}>
                    <Typography sx={{ textAlign: 'center' }} variant="caption">
                      {statoRichiesta +
                        ' il ' +
                        format(
                          new Date(
                            dettaglioPratica.dataChiusura,
                          ),
                          'dd/MM/yyyy',
                        )}
                    </Typography>
                  </Tooltip>)
                  : (<Typography sx={{ textAlign: 'center' }} variant="caption">
                    {statoRichiesta +
                      ' il ' +
                      format(
                        new Date(
                          dettaglioPratica.dataChiusura,
                        ),
                        'dd/MM/yyyy',
                      )}
                  </Typography>))
                : (<Typography sx={{ textAlign: 'center' }} variant="caption">
                    {statoRichiesta}
                  </Typography>
                )}
            </Stack>
            {(
              <Stack sx={{ width: '20%' }} alignItems="center">
                <Typography
                  sx={{ fontWeight: 900, textAlign: 'center' }}
                  variant="caption"
                >
                  {`AZIONI DA PORRE IN ESSERE`}
                </Typography>
                {statoRichiesta !== StatiPratica.chiusa ? (
                  <Typography variant="caption">N.D.</Typography>
                ) : (
                  azioniDaPorreInEssereUnique?.map((azione, index) => (
                    <Tooltip
                      key={index}
                      title={azione}
                      style={{ marginTop: '2px', maxWidth: '180px' }}
                    >
                      <Chip
                        sx={{
                          '& .MuiChip-root': {
                            borderRadius: 0,
                          },
                        }}
                        size="small"
                        label={azione}
                        key={azione}
                      />
                    </Tooltip>
                  ))
                )}
              </Stack>
            )}
          </Grid>
          {showButton && (
            <Stack sx={{ width: '9%' }}>
              {loading ? (
                <div style={{ marginLeft: '20px', marginTop: '1px' }}>
                  <CircularProgress />
                </div>
              ) : (
                <Tooltip key={'Stampa Riepilogo'} title="Stampa Riepilogo">
                  <IconButton onClick={getPdf}>
                    <PrintIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Stack>
          )}
        </AccordionSummary>
        <AccordionDetails>
          {((statoRichiesta === StatiPratica.daApprovare ||
              statoRichiesta === StatiPratica.chiusa) &&
            approvazioneDisponibile &&
            (isValidUser('AUTORIZZATIVO_ON_BOARDING') ||
              isValidUser('AUTORIZZATIVO_MONITORAGGIO') ||
              isValidUser('APPROVATORE_MONITORAGGIO') ||
              isValidUser('UTENTE_INTERNO') ||
              isValidUser('INQUERY')

            )
          ) ?
            (
              <SezioneBlu esitoAdv={validazioneEsitoAdv}
                          statoPratica={statoPratica}
                          assegnatario={dettaglioPratica.daAssegnare}
                          idPratica={idNodoPratica}
                          abilitaChiuso={dataAbilitazioneTastoChiuso}
                          tipoInserimento={dettaglioPratica.tipoInserimento}
                //refecthPratica={refetchPraticheDettaglio}
                          refecthPratica={handleReloadDettaglio}
                          handleReloadDettaglio={handleReloadDettaglio}
              />
            ) : null}
          {(statoRichiesta === StatiPratica.inAttesaOpzionali ||
            statoRichiesta === StatiPratica.checkOutOperatore ||
            statoRichiesta === StatiPratica.chiusa ||
            statoRichiesta === StatiPratica.daApprovare ||
            statoRichiesta === StatiPratica.infoComplete) && (
            <SezioneGialla esitoAdv={sezioneGiallaSalvata?.esitoAdv}
                           statoPratica={statoPratica}
                           assegnatario={dettaglioPratica.daAssegnare}
                           idPratica={idNodoPratica}
                           abilitaChiuso={dataAbilitazioneTastoChiuso}
                           tipoInserimento={dettaglioPratica.tipoInserimento}
              //refecthPratica={refetchPraticheDettaglio}
                           refecthPratica={handleReloadDettaglio}
                           handleReloadDettaglio={handleReloadDettaglio}
                           showSupportoConsulenziale={dettaglioPratica?.richiestaSupporto?.stato === 'PENDING'}
            />

          )}

          {(noteUtenteAutorizzativo !== null && noteUtenteAutorizzativo !== '') && (
            <Stack>
              <Typography variant="caption">NOTE UTENTE AUTORIZZATIVO</Typography>
              <Tooltip
                key={'NOTE UTENTE AUTORIZZATIVO'}
                title="NOTE UTENTE AUTORIZZATIVO"
              >
              <textarea
                style={{
                  margin: '2px',
                  minWidth: '100%',
                  width: '100%',
                  maxWidth: '100%',
                  height: '60px',
                  maxHeight: '50%',
                  minHeight: '60px',
                }}
                minows={3}
                defaultValue={noteUtenteAutorizzativo}
                disabled={true}
              ></textarea>
              </Tooltip>
            </Stack>
          )}
          <Accordion square disableGutters elevation={0}>
            {dataCartelleDocumenti && (
              <>
                <AccordionSummary
                  sx={{
                    backgroundColor: theme.palette.grey.dark,
                    width: '100%',
                  }}
                  onClick={() => {
                    setStatoRichiesta(statoRichiesta)
                  }}
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  DOCUMENTI ADEGUATA VERIFICA
                </AccordionSummary>
              </>
            )}


            {/*<AccordionDetails sx={{ backgroundColor: theme.palette.grey.dark }}>
              <AccordionDetails sx={{ backgroundColor: theme.palette.grey.dark }}>
                {isFetchingCartelleDocumenti && <CircularProgress />}
                {isFetchedCartelleDocumenti &&
                  dataCartelleDocumenti &&
                  dataCartelleDocumenti.map(cartella => (
                    <Accordion
                      key={cartella.id}
                      expanded={expanded === cartella.id}
                      onChange={handleChange(cartella.id)}
                      id={cartella.id}
                      square
                      disableGutters
                      elevation={0}
                    >
                      <AccordionSummary
                        sx={{
                          backgroundColor: theme.palette.grey.dark,
                          width: '100%',
                        }}
                        expandIcon={<ArrowDropDownIcon />}
                        aria-controls="panel1a-content"
                        onClick={() => setIdDocumenti(cartella.id)}
                        id="panel1a-header"
                      >
                        {cartella.name}
                      </AccordionSummary>
                      <AccordionDetails
                        sx={{
                          backgroundColor: theme.palette.grey.dark,
                        }}
                      >
                        <List>
                          {isFetchingListaDocumenti && <CircularProgress />}
                          {isFetchedListaDocumenti &&
                            dataListaDocumenti?.map(documento => (
                              <><ListItem

                                key={documento.id}
                                secondaryAction={
                                  <Box bgcolor={'black'}>
                                    <UploadDocument

                                      disabled={statoRichiesta === StatiPratica.chiusa ||
                                        uploadPermission(cartella.name)}
                                      key={documento.id}
                                      idDocumento={documento.id}
                                      onUpload={refreshListaDocAndStatoRichiesta}
                                      idPratica={idNodoPratica}
                                    />
                                  </Box>}>
                                {documento.nodeIsOptional === true && (
                                  <DeleteDocument
                                    key={`${documento.id}erase`}
                                    disabled={statoRichiesta ===
                                      StatiPratica.daApprovare ||
                                      statoRichiesta === StatiPratica.chiusa ||
                                      (isValidUser('UPLOAD_DOCUMENTI_ADV') ===
                                        false &&
                                        isValidUser(
                                          'DELETE_DOCUMENTI_ADV_OPZIONALI',
                                        ) === false)}
                                    idFile={documento.id}
                                    fileName={documento.name}
                                    onDelete={refreshListaDocAndStatoRichiesta}
                                    idPratica={idNodoPratica}
                                  />
                                )}
                                <Tooltip
                                  title={(documento.name === 'Richiesta AG UIF'
                                      ? titlesToolTip.RichiestaAgUif
                                      : '') ||
                                    (documento.name === 'Controlli AML e Gianos'
                                      ? titlesToolTip.ControlliAmleGianos
                                      : '')}
                                >
                                  <ListItemText
                                    key={documento.name}
                                    primary={documento.name}
                                    sx={{
                                      maxWidth: '100%',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      //whiteSpace: 'nowrap'
                                      whiteSpace: 'normal',
                                      wordBreak: 'break-word',
                                    }}
                                  />
                                </Tooltip>
                              </ListItem>
                                <Stack
                                  direction={'column'}
                                  spacing={-2}
                                >
                                  {documento.children &&
                                    documento.children.length > 0 &&
                                    documento.children
                                      .filter(child => child.nodeIsFile)
                                      .map(file => (
                                        <>
                                          <ListItem
                                            key={'subDirectories'}
                                            direction={'row'}
                                            spacing={-2}
                                            sx={{ alignItems: 'center' }}

                                          >
                                            {documentsToView.includes(
                                              file.id,
                                            ) ? (
                                              <><Tooltip title={`${file.name}`}>
                                                <IconButton
                                                  onClick={() => handleOpenMenu(file.id)}
                                                >
                                                  <SummarizeIcon sx={{

                                                    margin: '8px',
                                                    '& > *': { margin: '-4px' },
                                                    marginRight: '18px',
                                                    '& > **': { margin: '-14px' },
                                                  }} />
                                                </IconButton>
                                              </Tooltip>
                                                <Stack
                                                  direction="row"
                                                  sx={{ margin: '-8px', '& > *': { margin: '4px' } }}
                                                  alignItems="center"
                                                >
                                                  <Typography variant="caption" >{file.name}</Typography>

                                                  <Tooltip
                                                    key={`${file.name}`}
                                                    title={`${file.name}`}
                                                  >
                                                    <IconButton
                                                      aria-label="View Document"
                                                      key={`${file.id}erase`}
                                                      onClick={(event) => clickDoc(event, file.id, file.name)}
                                                      disabled={!isPDF(file.name)} // disabilita il bottone file nn PDF
                                                    >
                                                      <VisibilityIcon
                                                        sx={{ margin: '8px', '& > *': { margin: '4px' } }} />
                                                    </IconButton>
                                                  </Tooltip>
                                                  <Tooltip
                                                    title={`${file.name}`}
                                                  >
                                                    <IconButton
                                                      key={file.id}
                                                      onClick={event => handleDownloadFile(event, file.id, file.name)}

                                                    >
                                                      <FileDownloadIcon
                                                        sx={{ margin: '8px', '& > *': { margin: '4px' } }} />
                                                    </IconButton>
                                                  </Tooltip>
                                                  <DeleteDocument
                                                    sx={{ margin: '8px', '& > *': { margin: '4px' } }}
                                                    key={`${file.id}erase`}
                                                    disabled={statoRichiesta ===
                                                      StatiPratica.daApprovare ||
                                                      statoRichiesta ===
                                                      StatiPratica.chiusa ||
                                                      uploadPermission(
                                                        cartella.name,
                                                      )}
                                                    idFile={file.id}
                                                    fileName={file.name}
                                                    onDelete={refreshListaDocAndStatoRichiesta}
                                                    idPratica={idNodoPratica} />
                                                </Stack>

                                              </>
                                            ) : (
                                              <Tooltip title={`${file.name}`}>
                                                <IconButton
                                                  onClick={() => handleOpenMenu(file.id)}
                                                >
                                                  <SummarizeIcon />
                                                </IconButton>
                                              </Tooltip>
                                            )}
                                          </ListItem>
                                        </>
                                      ))}

                                </Stack></>
                            ))}
                          {isFetchedListaDocumenti &&
                            cartella.name !== 'Documenti per adeguata verifica' &&
                            statoRichiesta !== StatiPratica.daApprovare &&
                            statoRichiesta !== StatiPratica.chiusa && (
                              <Stack sx={{ m: 2 }} direction={'row'}>
                                <Typography sx={{ mr: 1, mb: -2, mt: 0.3 }}>
                                  Ulteriore documentazione ove presente
                                </Typography>

                                <TextFieldCreateFolder
                                  folderId={cartella.id}
                                  onSubmit={refreshListaDoc}
                                  listaDocs={dataListaDocumenti}
                                  idPratica={idNodoPratica}
                                ></TextFieldCreateFolder>
                              </Stack>
                            )}
                        </List>
                      </AccordionDetails>
                    </Accordion>
                  ))}
              </AccordionDetails>
            </AccordionDetails>*/}
            <AccordionDetails sx={{ backgroundColor: theme.palette.grey.dark }}>
              {isFetchingCartelleDocumenti && <CircularProgress />}
              {isFetchedCartelleDocumenti &&
                dataCartelleDocumenti &&
                dataCartelleDocumenti.map(cartella => (
                  <Accordion
                    key={cartella.id}
                    expanded={expanded === cartella.id}
                    onChange={handleChange(cartella.id)}
                    id={cartella.id}
                    square
                    disableGutters
                    elevation={0}
                  >
                    <AccordionSummary
                      sx={{
                        backgroundColor: theme.palette.grey.dark,
                        width: '100%',
                      }}
                      expandIcon={<ArrowDropDownIcon />}
                      aria-controls="panel1a-content"
                      onClick={() => setIdDocumenti(cartella.id)}
                      id="panel1a-header"
                    >
                      {cartella.name}
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: theme.palette.grey.dark }}>
                      <List>
                        {isFetchingListaDocumenti && <CircularProgress />}
                        {isFetchedListaDocumenti &&
                          dataListaDocumenti?.map(documento => (
                            <>
                              <ListItem
                                key={documento.id}
                                secondaryAction={
                                  <Box bgcolor={'black'} mr={5}>
                                    <UploadDocument
                                      disabled={
                                        statoRichiesta === StatiPratica.chiusa ||
                                        uploadPermission(cartella.name)
                                      }
                                      key={documento.id}
                                      idDocumento={documento.id}
                                      onUpload={refreshListaDocAndStatoRichiesta}
                                      idPratica={idNodoPratica}
                                    />
                                  </Box>
                                }
                              >
                                {documento.nodeIsOptional === true && (
                                  <DeleteDocument
                                    key={`${documento.id}erase`}
                                    disabled={
                                      statoRichiesta === StatiPratica.daApprovare ||
                                      statoRichiesta === StatiPratica.chiusa ||
                                      (isValidUser('UPLOAD_DOCUMENTI_ADV') === false &&
                                        isValidUser('DELETE_DOCUMENTI_ADV_OPZIONALI') === false)
                                    }
                                    idFile={documento.id}
                                    fileName={documento.name}
                                    onDelete={refreshListaDocAndStatoRichiesta}
                                    idPratica={idNodoPratica}
                                  />
                                )}
                                <Tooltip
                                  title={
                                    (documento.name === 'Richiesta AG UIF'
                                      ? titlesToolTip.RichiestaAgUif
                                      : '') ||
                                    (documento.name === 'Controlli AML e Gianos'
                                      ? titlesToolTip.ControlliAmleGianos
                                      : '')
                                  }
                                >
                                  <ListItemText
                                    key={documento.name}
                                    primary={documento.name}
                                    sx={{
                                      maxWidth: '100%',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'normal',
                                      wordBreak: 'break-word',
                                    }}
                                  />
                                </Tooltip>
                              </ListItem>

                              {/* Stack per le voci figlio (file) */}
                              <Stack direction={'column'} spacing={-2}>
                                {documento.children &&
                                  documento.children.length > 0 &&
                                  documento.children
                                    .filter(child => child.nodeIsFile)
                                    .map((file, index) => (
                                      <ListItem
                                        key={'subDirectories'}
                                        direction={'row'}
                                        spacing={-2}
                                        sx={{
                                          alignItems: 'center',
                                          width: '100%',
                                          //backgroundColor: index % 2 ===0 ? theme.palette.grey[300] : theme.palette.grey[200]
                                        }}
                                      >
                                        {/*
                                        <PictureAsPdfIcon fontSize={"medium"} sx={{marginRight: '18px', marginLeft: '25px' }} />
*/}
                                        {/* Icone a destra */}
                                        <Stack
                                          direction="row"
                                          sx={{
                                            ml: 'auto', // Spinge le icone a destra
                                            '& > *': {
                                              margin: '4px',
                                            },
                                          }}
                                        >
                                          <Tooltip title={`Visualizza documento: ${file.name}`}>
                                            <IconButton
                                              onClick={(event) => clickDoc(event, file.id, file.name)}
                                              disabled={!isPDF(file.name)}
                                            >
                                              <VisibilityIcon sx={{ margin: '8px' }} />
                                            </IconButton>
                                          </Tooltip>

                                          <Tooltip title={`Scarica documento : ${file.name}`}>
                                            <IconButton
                                              onClick={(event) => handleDownloadFile(event, file.id, file.name)}
                                            >
                                              <FileDownloadIcon sx={{ margin: '8px' }} />
                                            </IconButton>
                                          </Tooltip>

                                          <DeleteDocument
                                            sx={{ margin: '8px' }}
                                            key={`${file.id}erase`}
                                            disabled={
                                              (statoRichiesta === StatiPratica.daApprovare && !isValidUser('UTENTE_INTERNO')) ||
                                              statoRichiesta === StatiPratica.chiusa ||
                                              uploadPermission(cartella.name)
                                            }
                                            idFile={file.id}
                                            fileName={file.name}
                                            onDelete={refreshListaDocAndStatoRichiesta}
                                            idPratica={idNodoPratica}
                                          />
                                        </Stack>
                                        <Stack
                                          direction="row"
                                          sx={{
                                            width: '100%',  // Occupa tutta la larghezza disponibile
                                            alignItems: 'center',
                                          }}
                                        >
                                          {/* Nome del file */}
                                          <Tooltip title={`${file.name}`}>

                                            <Typography
                                              variant="h4"
                                              sx={{
                                                flexGrow: 1,  // Questo fa occupare tutto lo spazio disponibile
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                fontSize: '0.875rem',
                                              }}
                                            >
                                              Nome file: {file.name}
                                            </Typography>
                                          </Tooltip>


                                        </Stack>
                                      </ListItem>
                                    ))}
                              </Stack>
                            </>
                          ))}
                        {isFetchedListaDocumenti &&
                          cartella.name !== 'Documenti per adeguata verifica' &&
                          statoRichiesta !== StatiPratica.daApprovare &&
                          statoRichiesta !== StatiPratica.chiusa && (
                            <Stack sx={{ m: 2 }} direction={'row'}>
                              <Typography sx={{ mr: 1, mb: -2, mt: 0.3 }}>
                                Ulteriore documentazione ove presente
                              </Typography>

                              <TextFieldCreateFolder
                                folderId={cartella.id}
                                onSubmit={refreshListaDoc}
                                listaDocs={dataListaDocumenti}
                                idPratica={idNodoPratica}
                              ></TextFieldCreateFolder>
                            </Stack>
                          )}
                      </List>
                    </AccordionDetails>
                  </Accordion>
                ))}
            </AccordionDetails>

            {((statoRichiesta === StatiPratica.checkOutOperatore) &&
              isValidUser('UPLOAD_DOCUMENTI_ADV') === true) && (
              <OnlyWithFunction acceptedFunction="UPLOAD_DOCUMENTI_ADV">
                <AccordionActions
                  sx={{
                    backgroundColor: theme.palette.grey.dark,
                    width: '100%',
                    alignItems: 'center',
                    padding: 0,
                  }}
                >
                  <StyledButton
                    disabled={(

                      statoRichiesta === StatiPratica.infoComplete ||
                      statoRichiesta === StatiPratica.daApprovare ||
                      statoRichiesta === StatiPratica.chiusa)
                    }
                    onClick={handleOpenModal}
                    sx={{
                      backgroundColor: theme.palette.yellow.dark,
                      borderRadius: '5px 0px 0px 5px',
                      border: 'none',
                    }}
                  >
                    RESTART CARICAMENTO AUTOMATICO
                  </StyledButton>

                  <Dialog
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle
                      id="alert-dialog-title">{'Conferma riavvio caricamento documenti per adeguata verifica'}</DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Sei sicuro di voler riavviare la procedura di auto caricamento dei documenti? Questa azione non
                        può essere annullata.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleConfirmAutoRestartCaricamentoDoc} color="primary" autoFocus>
                        Conferma
                      </Button>
                      <Button onClick={handleCloseModal} color="primary">
                        Annulla
                      </Button>

                    </DialogActions>
                  </Dialog>

                </AccordionActions>
              </OnlyWithFunction>
            )}
            {((statoRichiesta === StatiPratica.inRichiesta ||
                statoRichiesta === StatiPratica.inLavorazione) &&
              dettaglioPratica.daAssegnare === JSON.parse(localStorage.getItem('user'))) && (
              <OnlyWithFunction acceptedFunction="CHIUDI">
                <AccordionActions
                  sx={{
                    backgroundColor: theme.palette.grey.dark,
                    width: '100%',
                    alignItems: 'center',
                    padding: 0,
                  }}
                >
                  <StyledButton
                    disabled={(
                      isValidUser('CHIUDI') === false ||
                      statoRichiesta === StatiPratica.daApprovare ||
                      statoRichiesta === StatiPratica.chiusa)
                    }
                    onClick={handleOpenModal}
                    sx={{
                      backgroundColor: theme.palette.yellow.dark,
                      borderRadius: '5px 0px 0px 5px',
                      border: 'none',
                    }}
                  >
                    Chiudi
                  </StyledButton>

                  <Dialog
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">{'Conferma chiusura pratica'}</DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Sei sicuro di voler chiudere questa pratica? Questa azione non può essere annullata.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleConfirmClosePratica} color="primary" autoFocus>
                        Conferma
                      </Button>
                      <Button onClick={handleCloseModal} color="primary">
                        Annulla
                      </Button>

                    </DialogActions>
                  </Dialog>

                </AccordionActions>
              </OnlyWithFunction>
            )}
            {(statoRichiesta === StatiPratica.valutazionePreliminare &&
              dettaglioPratica.daAssegnare === JSON.parse(localStorage.getItem('user'))) && (
              <OnlyWithFunction acceptedFunction="CHIUDI">
                <AccordionActions
                  sx={{
                    backgroundColor: theme.palette.grey.dark,
                    width: '100%',
                    alignItems: 'center',
                    padding: 0,
                  }}
                >
                  <StyledButton
                    disabled={(
                      isValidUser('CHIUDI') === false ||
                      statoRichiesta === StatiPratica.daApprovare ||
                      statoRichiesta === StatiPratica.chiusa)
                    }
                    onClick={handleOpenModal}
                    sx={{
                      backgroundColor: theme.palette.yellow.dark,
                      borderRadius: '5px 0px 0px 5px',
                      border: 'none',
                    }}
                  >
                    Apri ADV
                  </StyledButton>

                  <Dialog
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">{'Conferma chiusura pratica'}</DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Sei sicuro di voler aprire una adeguata verifica per questa posizione? Questa azione non può
                        essere annullata.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleConfirmClosePratica} color="primary" autoFocus>
                        Conferma
                      </Button>
                      <Button onClick={handleCloseModal} color="primary">
                        Annulla
                      </Button>

                    </DialogActions>
                  </Dialog>

                </AccordionActions>
              </OnlyWithFunction>
            )}
          </Accordion>
          {dettaglioPratica.listDatiMonitoraggio.length > 0 && <EvidenzaEsitoMonitoraggio
            listDatiMonitoraggio={dettaglioPratica.listDatiMonitoraggio}></EvidenzaEsitoMonitoraggio>}


        </AccordionDetails>
      </Accordion>
      {
        startPol && (
          <Stack variant="outlined"
                 sx={tableStyle}
                 onMouseLeave={openAdvAutomatica}
                 square>
            {/* <Paper
              variant="outlined"
              sx={tableStyle}
              onMouseLeave={openAdvAutomatica}
              square
            >*/}
            <DataTable indicatoriPratica={indicatoriPratica}></DataTable>
            {/* </Paper>*/}
          </Stack>

        )
      }
    </>
  )
}

export default AccordionDettaglio
